var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFieldHockey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M11.229 8.147a3.395 3.395 0 1 1 3.09-1.498l-.123-.05c-1.535-.64-2.943-.088-2.966 1.475l-.001.073z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.594 8.249c1.876 0 4.517-2.445 2.907-5.953l-.13-.132c-.672-.677 1.393 1.639-.987 3.508-1.192-.293-1.963.138-2.316 1.292l-.114.034c-.786.23-1.347.341-1.684.33.608.571 1.425.92 2.324.92z",
    mask: "url(#b)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D28446",
    d: "M3.002 7.244l5.048.35.62.687-5.075-.36-.593-.677zM1.869 5.951l-.64-.73 4.995.35.66.733L1.87 5.95zM.096 3.928L0 3.818l2.727-2.12 2.327 2.577-4.958-.347zm9.757 5.639c1.07.982 1.747.58 1.767.1l.027-1.775c.026-1.41 2.678-1.543 3.096-.256 1.592 5.473-4.585 8.241-8.163 3.692L4.717 9.202l5.136.365z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.147 4.386l.97 1.073-5-.35L.17 4.038l4.977.348zm1.83 2.024l.969 1.073-5.039-.352-.948-1.072 5.017.351zM8.76 8.384l.97 1.073-5.078-.355-.948-1.071 5.056.353z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.12 12.029c1.728-1.442 1.635-3.865 1.623-4.374 1.592 5.473-4.585 8.242-8.163 3.693 2.512 1.695 4.692 1.922 6.54.68z",
    opacity: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldHockey);
export default __webpack_public_path__ + "static/media/field_hockey.854ed45fe1c60b34a2011c4b25855656.svg";
export { ForwardRef as ReactComponent };